

//#region Asset Imports

import { IMRBaseComponent } from '../base'
import { GridMasterDetailsController } from './grid-master-details.controller'

import * as TEMPLATE from './grid-master-details.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'gridMasterDetails'

export class GridMasterDetailsComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: GridMasterDetailsController,
            template: TEMPLATE,
            services: []
        })
    }

}